import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { updatePricing, updateGroupPricing } from "../../../../services/profile";
import { toast } from "react-toastify";
import { setLoading } from "../../../../reducer/auth/auth";
import { useTranslation } from "react-i18next";

export default function GroupSessions(props) {
  const { t } = useTranslation("mediumPricing");
  const dispatch = useDispatch();
  const [group, setGroup] = useState(false);
  const [coaching, setCoaching] = useState(false);
  const { stepOneData, id, onProfileUpdate } = props;
  const { coaching_pricing_30, coaching_pricing_60, session_currency } = stepOneData || {};
  useEffect(() => {
    console.log(stepOneData, "data");
  }, []);
  const { sessionPreferences } = useSelector((state) => state.user.user);
  const prefs = Array.isArray(sessionPreferences) ? sessionPreferences : [];
  const hasGroupSession = prefs.includes("Group Session");
  const hasPracticeCircle = prefs.includes("Practice Circles");
  useEffect(() => {
    console.log("prefs", prefs);
    if (hasGroupSession) {
      setGroup(true);
    }

    if (hasPracticeCircle) {
      setCoaching(true);
    }
  }, []);
  const handleSectionSubmit = (sectionName, values) => {
    const { session_currency, sessionPrices, coachingPrices, groupPrices, DemonstrationsPrices } = values;
let currency = session_currency;
    let item = {
      userId: id,
    };

    let errors = [];

    const OPTIONAL_FIELD = "Speaker Events";

    Object.entries(groupPrices).forEach(([key, value]) => {
      if (key === OPTIONAL_FIELD) return; // skip validation

      if (value === "" || value === null || isNaN(value) || Number(value) < 0) {
        errors.push(t("shared.priceRequired", { name: t(`groupSessions.names.${key}`, { defaultValue: key }) }));
      }
    });

    if (errors.length > 0) {
      errors.forEach(err => toast.error(err));
      return;
    }
    // If all valid → convert to array
    const price_for_attendees = Object.entries(groupPrices).map(([key, value]) =>
      value === "" ? 0 : Number(value)
    );

    const groupcoaching = process.env.REACT_APP_COACHING_GROUP_SESSION_ID;
    let  payload = {
      medium_id: id,
      session_type: [2, 2, 29],
      subsession_type: [Number(groupcoaching), 94, 95],
      price_for_attendees: price_for_attendees
    };
    payload = {
             ...payload,
             session_currency: JSON.stringify({
               30: currency,
               45: currency,
               60: currency,
               452: currency,
               602: currency,
             }),
       
           };
     
    updateGroupPricing(payload)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          toast.success(t("shared.pricingUpdated"), { position: "top-center" });
          if (typeof onProfileUpdate === 'function') {
            onProfileUpdate(); // Call the parent function
          } else {
            console.error('onProfileUpdate is not a function');
          }
        } else {
          toast.error(data.data.message);
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(err);
      });



  };
  return (
    <div className="pricing-card">
      <Formik
        enableReinitialize // 👈 very important!
        initialValues={{
          session_currency: stepOneData && stepOneData.session_currency
            ? stepOneData.session_currency
            : "USD",
          groupPrices: {
            "Group Coaching": stepOneData && stepOneData.group_coaching ? stepOneData.group_coaching : 0,
            "Coached Practice Circles": stepOneData && stepOneData.coached_practice_circles ? stepOneData.coached_practice_circles : 0,
            "Speaker Events": stepOneData && stepOneData.speaker_events ? stepOneData.speaker_events : 0,
          },
          DemonstrationsPrices: {
            "Practice Demo": stepOneData && stepOneData.demo_practice ? stepOneData.demo_practice : 0,

          },
          ExtraServicesPricing:
            stepOneData && stepOneData.extra_services_list
              ? stepOneData.extra_services_list.reduce((acc, item) => {
                acc[item.name] =
                  item.amount !== null && item.amount !== undefined ? item.amount : "";
                return acc;
              }, {})
              : {},
        }}
        onSubmit={(values) => {
          console.log("Formik form values:", values);
          //handleSubmit(values);
          // call your save API here
        }}
      >
        {({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
}) => (
          <Form>
            <div className="pricing-card-intro">
              <p className="pricing-card-desc">{t("shared.enterPricing")}</p>
              <div className="pricing-note-box">
                <p className="pricing-note-text">{t("shared.pricingNote")}</p>
              </div>
            </div>

            {group && (
              <div className="pricing-row">
                <div className="pricing-row-label">
                  <span className="pricing-accent-bar"></span>
                  <label>{t("groupSessions.groupCoachingTbd")}</label>
                </div>
                <div className="pricing-amount-box">
                  <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                  <Field
                    type="text"
                    name="groupPrices.Group Coaching"
                    className="amount_input pricing-amount-input"
                    placeholder="0.00"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </div>
              </div>
            )}

            {coaching && (
              <div className="pricing-row">
                <div className="pricing-row-label">
                  <span className="pricing-accent-bar"></span>
                  <label>{t("groupSessions.coachedPracticeCircles")}</label>
                </div>
                <div className="pricing-amount-box">
                  <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                  <Field
                    type="text"
                    name="groupPrices.Coached Practice Circles"
                    className="amount_input pricing-amount-input"
                    placeholder="0.00"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </div>
              </div>
            )}

            {group && (
              <div className="pricing-row">
                <div className="pricing-row-label">
                  <span className="pricing-accent-bar"></span>
                  <label>{t("groupSessions.speakerEvents")}</label>
                </div>
                <div className="pricing-amount-box">
                  <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                  <Field
                    type="text"
                    name="groupPrices.Speaker Events"
                    className="amount_input pricing-amount-input"
                    placeholder="0.00"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </div>
              </div>
            )}

            <div className="pricing-row pricing-row-currency">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label>{t("shared.sessionCurrency")}</label>
              </div>
              <div className="pricing-currency-group">
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_usd"
                    value="USD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "USD"}
                  />
                  <label htmlFor="session_currency_usd">USD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_cad"
                    value="CAD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "CAD"}
                  />
                  <label htmlFor="session_currency_cad">CAD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_aud"
                    value="AUD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "AUD"}
                  />
                  <label htmlFor="session_currency_aud">AUD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_eur"
                    value="EUR"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "EUR"}
                  />
                  <label htmlFor="session_currency_eur">EUR</label>
                </span>
              </div>
            </div>

            <span className="error text-left">
              {errors.currency &&
                touched.currency &&
                errors.currency}
            </span>

            <div className="pricing-card-footer">
              <button type="submit" className="resend-btn pricing-update-btn" onClick={() => handleSectionSubmit("group", values)}>
                {t("shared.submit")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
